import { render } from "./RegisterStep1.vue?vue&type=template&id=e95bca1a&scoped=true"
import script from "./RegisterStep1.vue?vue&type=script&lang=js"
export * from "./RegisterStep1.vue?vue&type=script&lang=js"

import "./RegisterStep1.vue?vue&type=style&index=0&id=e95bca1a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95bca1a"]])

export default __exports__